import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "homeBox" }
const _hoisted_2 = { class: "homeWrap mainBox" }

import imageUrl from "@/utils/oss";
import Banner from "./components/banner.vue";
import news from "./components/news.vue";
import SoftProduct from "./components/softProduct.vue";
import Product from "./components/product.vue";
import AIProduct from "./components/aiProduct.vue";
import menusCheck from "./components/menusCheck";
import Chart from "./components/chart.vue";
import Examples from "./components/examples.vue";
import { ref, onMounted, nextTick, onUnmounted } from "vue";
import { WOW } from "wowjs";
import HomeApi from "@/api/homeApi.js";
import { navTo } from "@/utils/util";
import LibraryEcology from "./components/libraryEcology.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const homeApi = new HomeApi();

const chartBoxRef = ref(null);
const chartRef = ref(null);
const chartPositionTop = ref(0);

//解决方案
const solutionRef = ref(null);
const solutionTop = ref(0);

//悬浮按钮是否固定
const isFixed = ref(false);

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

onMounted(() => {
  //初始化wow
  const wow = new WOW();
  wow.init();

  //获取定位
  getPostion();

  //监听页面滚动事件
  window.addEventListener("scroll", handleScroll);
});

//计算定位
const getPostion = () => {
  setTimeout(() => {
    if (chartBoxRef.value) {
      const rect = chartBoxRef.value.getBoundingClientRect();
      chartPositionTop.value = rect.top - document.body.clientHeight;
      // console.log("rect", rect); // 输出位置和尺寸信息
    }

    //获取元素高度
    if (solutionRef.value) {
      const rect = solutionRef.value.getBoundingClientRect();
      solutionTop.value = rect.top - document.body.clientHeight;
    }
  }, 1000);
};

//处理滚动事件
const handleScroll = (event) => {
  //展示图表动画
  if (
    window.scrollY >= chartPositionTop.value &&
    window.scrollY >= chartPositionTop.value + 500
  ) {
    chartRef.value?.animate();
  }

  //如果滚动超过悬浮按钮高度，悬浮按钮就固定
  if (window.scrollY >= 640) {
    isFixed.value = true;
  } else {
    isFixed.value = false;
  }
};

/**
 * 点击行业解决方案
 */
const clickSolution = () => {
  window.scrollTo({
    top: solutionTop.value + document.body.clientHeight - 50,
    behavior: "smooth",
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, { onClickSolution: clickSolution }),
    _createVNode(LibraryEcology),
    _createElementVNode("div", {
      class: "homeWrap mainBox",
      ref_key: "solutionRef",
      ref: solutionRef
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "title",
        style: {"text-align":"center"}
      }, [
        _createElementVNode("div", { class: "text1" }, "方案场景"),
        _createElementVNode("div", { class: "text2" }, "提供丰富、安全、稳定、智能的产品及服务方案")
      ], -1)),
      _createVNode(_unref(menusCheck))
    ], 512),
    _createVNode(AIProduct),
    _createVNode(SoftProduct),
    _createVNode(Product),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "title",
        style: {"text-align":"center"}
      }, [
        _createElementVNode("div", { class: "text1" }, "行业领先智能安全管控平台"),
        _createElementVNode("div", { class: "text2" }, "多维度数据全景呈现,见证企业发展实力")
      ], -1)),
      _createElementVNode("div", {
        class: "chartBox",
        ref_key: "chartBoxRef",
        ref: chartBoxRef
      }, [
        _createVNode(Chart, {
          ref_key: "chartRef",
          ref: chartRef
        }, null, 512)
      ], 512)
    ]),
    _createVNode(Examples),
    _createVNode(news)
  ]))
}
}

})